module.exports = __webpack_public_path__ + "media/media/about/industry_leading-ff105de0c966e536c4b0226911e2378d.png";